module.exports = __webpack_public_path__ + "static/img/faq-banner-two.6cba00ec.jpg";